import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { updateData } from '../../../services';
import { useState } from 'react';
import Modal from '../../helpers/Modal';
// Project stages from Tracker component
const stages = [
    { id: 'draft', label: 'Draft' },
    { id: 'quoted', label: 'Quoted' },
    { id: 'prepare to build', label: 'Prepare to Build' },
    { id: 'manufacturing', label: 'Manufacturing' },
    { id: 'shipped', label: 'Shipped' }
];

export const ChangeStageForm = ({ project }) => {
    const { token, base_url, setProjects } = useAppContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedStage, setSelectedStage] = useState(project.current_stage || 'draft');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (selectedStage === project.current_stage) {
            window.showAlert(400, 'Project is already in this stage.');
            return;
        }

        setIsSubmitting(true);

        const data = {
            current_stage: selectedStage
        };

        try {
            console.log('Changing stage for project:', project.id, 'to:', selectedStage);
            const updated_project = await updateData(token, `${base_url}/apis/projects/${project.id}`, data);
            
            if (updated_project.project) {
                // Update the project in the projects list in context
                setProjects(prevProjects => 
                    prevProjects.map(p => 
                        p.id === project.id ? updated_project.project : p
                    )
                );

                // Show success alert
                window.showAlert(200, `Project stage updated to ${stages.find(s => s.id === selectedStage)?.label} successfully!`);
                console.log('Project stage updated successfully!');
            }

            setIsModalOpen(false);
        } catch (error) {
            console.error('Error updating stage for project:', error);
            
            // Show error alert based on error type
            if (error.status === 404) {
                window.showAlert(404, 'Project not found');
            } else if (error.status >= 400 && error.status < 500) {
                window.showAlert(error.status, 'Invalid project data. Please check your input.');
            } else {
                window.showAlert(500, 'Failed to update project stage. Please try again.');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const changeStageForm = (
        <div>
            <h2>Change Project Stage</h2>
            <p>Select a new stage for this project:</p>
            <p><strong>Project: {project?.project_name}</strong></p>
            <p><strong>Current Stage: {stages.find(s => s.id === project?.current_stage)?.label || 'Unknown'}</strong></p>
            
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="stageSelect" className="form-label">
                        New Stage
                    </label>
                    <select
                        id="stageSelect"
                        value={selectedStage}
                        onChange={(e) => setSelectedStage(e.target.value)}
                        className="form-control"
                        required
                    >
                        {stages.map(stage => (
                            <option key={stage.id} value={stage.id}>
                                {stage.label}
                            </option>
                        ))}
                    </select>
                </div>
                
                <div className="form-actions">
                    <button
                        type="button"
                        onClick={() => setIsModalOpen(false)}
                        className="btn btn-secondary"
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Updating...' : 'Update Stage'}
                    </button>
                </div>
            </form>
        </div>
    );

    return (
        <>
            <button 
                onClick={() => setIsModalOpen(true)} 
                className="btn btn-secondary"
                title="Change Project Stage"
            >
                <FontAwesomeIcon icon={faExchangeAlt} />
                &nbsp;
                Change Stage
            </button>
            {isModalOpen && (
                <Modal form={changeStageForm} setIsModalOpen={setIsModalOpen} />
            )}
        </>
    );
};
